export const POLLING_INTERVALS = {
  DEFAULT: 5000,
  calculation: 2000,
  orders: 5000,
  quotes: 5000,
  jobsTable: 30000,
  documentsTable: 30000,
  deliveries: 10000,
  dashboard: 10000,
  productionFloor: 10000,
  jobModal: 10000,
  displayProfitProfiles: 10000,
  quickSetup: 3000,
  fileServiceStatus: 5000,
  filesStatus: 3000,
  filesUploader: 3000,
  messenger: 3000,
  ai: 3000,
  createPrintHouseTest: 3000,
  updateQuoteStatus: 20000,
  emailOrderSuggestion: 15000,
  globalAiStatus: 15000,
  documentReport: 3000,
} as const;
